export abstract class UserDao {
  abstract registerUser(): Promise<number>
}
